import { Ref } from "react";
import Logo, { LogoNames } from "../Logo";
import { UseCaseCustomerCarouselProps } from "./index";

type CardCarouselProps = {
  customers: UseCaseCustomerCarouselProps['customers'];
  sliderRef: Ref<HTMLDivElement>;
};

const isValidLogoType = (type: string): type is keyof typeof LogoNames => {
  return type in LogoNames;
};

export const CardCarousel = ({ customers = [], sliderRef }: CardCarouselProps) => {
  return (
    <div ref={sliderRef} className="keen-slider overflow-visible">
      {customers.map((customer, index) => (
        <div
          key={`customer-carousel-${customer.authorName?.replace(/\s+/g, '-') ?? index}`}
          className="keen-slider__slide rounded-10 overflow-hidden bg-violet-200 text-violet-900 p-3 md:py-4 md:px-6"
        >
          <div className="flex flex-col gap-3">
            {typeof customer.icon === 'string' && isValidLogoType(customer.icon) ?
              <div data-theme="theme-white" className="-my-2"><Logo type={customer.icon} /></div>
              : customer.icon}
            <div className="font-sans text-14/20 md:text-20/28 rich-text">{customer.quote}</div>
            <div className="flex gap-3 items-center">
              <div>
                <p className="text-17/24">{customer.authorName}</p>
                <p className="text-10/14 uppercase tracking-wide text-violet-800">{customer.authorTitle}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
